'use strict';

import Commission from '../finance/commission';
import Price from '../finance/price';

function DealCondition (data, dictionary) {
  // чистая продажа
  this.clearSale = data.get('isClearSale');

  // вариант подобран
  this.exchangePicked = data.get('isExchangePicked');

  // обменный вариант
  this.exchange = data.get('isExchange');

  // эксклюзивный договор
  this.exclusive = data.get('isExclusive');

  // коммиссия риэлтору
  const commission = data.get('commissionRealtor');
  this.commissionRealtor = commission ? new Commission(commission.get('required'), commission.get('amount')) : null;

  /** @var SaleType|null clearSale || exchangePicked || exchange */
  // this.saleType = null;

  /** @var Period|null период сдачи */
  this.period = dictionary.getRentPeriod(data.get('rentPeriodId')) || null;

  /** @var Gender|null предпочтения по половому признаку */
  this.genderPreference = dictionary.getGender(data.get('tenantGenderPreferenceId')) || null;

  /** @var PersonsNumber|null предпочтения по кол-ву человек */
  this.personsCount = dictionary.getPersonNumber(data.get('tenantCountPreferenceId')) || null;

  /** @var bool|null Документы готовы */
  this.docsReady = data.get('areDocsReady', null);

  /** @var bool|null ипотека */
  this.mortgageAvailable = data.get('isMortgageAvailable', null);

  /** @var bool|null военная ипотека */
  this.militaryMortgageAvailable = data.get('isMilitaryMortgageAvailable', null);

  /** @var bool|null ипотека с материнским капиталом */
  this.maternalCapitalAvailable = data.get('isMaternalCapitalAvailable', null);

  /** @var bool|null Можно с детьми */
  this.childrenAllowed = data.get('isChildrenAllowed', null);

  /** @var bool|null Можно с животными */
  this.animalsAllowed = data.get('isAnimalsAllowed', null);

  /** @var bool|null */
  this.deposit = data.get('needDeposit', null);

  const utilities = data.get('utilities', null);
  this.utilitiesPayment = utilities ? utilities.get('utilitiesId') : null;

  /** @var Price|null */
  this.utilitiesPrice = (utilities && utilities.get('price')) ? new Price(utilities.get('price')) : null;

  /**
   isInstallment: 'рассрочка',
   isPrepaid: 'внесён аванс',
   */
}
/**
 * Чистая продажа
 * @returns {*}
 */
DealCondition.prototype.isClearSale = function () {
  return this.clearSale;
};

DealCondition.prototype.getLabelClearSale = function () {
  return this.isClearSale() ? 'чистая продажа' : '';
};

/**
 * Вариант подобран
 * @returns {*}
 */
DealCondition.prototype.isExchangePicked = function () {
  return this.exchangePicked;
};

DealCondition.prototype.getLabelExchangePicked = function () {
  return this.isExchangePicked() ? 'вариант подобран' : '';
};

/**
 * Обменный вариант
 * @returns {*}
 */
DealCondition.prototype.isExchange = function () {
  return this.exchange;
};

DealCondition.prototype.getLabelExchange = function () {
  return this.isExchange() ? 'обменный вариант' : '';
};

/**
 * Эксклюзивный договор
 * @returns {*}
 */
DealCondition.prototype.isExclusive = function () {
  return this.exclusive;
};

DealCondition.prototype.getLabelExclusive = function () {
  return this.isExclusive() ? 'эксклюзив' : '';
};

DealCondition.prototype.hasDocs = function () {
  return this.docsReady;
};

DealCondition.prototype.getRentPeriod = function () {
  return this.period;
};

DealCondition.prototype.getCommissionRealtor = function () {
  return this.commissionRealtor;
};

DealCondition.prototype.isMortgage = function () {
  return this.mortgageAvailable;
};

DealCondition.prototype.isMilitaryMortgage = function () {
  return this.militaryMortgageAvailable;
};

DealCondition.prototype.isMaternalCapital = function () {
  return this.maternalCapitalAvailable;
};

DealCondition.prototype.isChildren = function () {
  return this.childrenAllowed;
};

DealCondition.prototype.getLabelChildrenAllow = function () {
  if (this.isChildren() === null) {
    return '';
  }

  return this.isChildren() ? 'с\u00A0детьми' : 'без\u00A0детей';
};

DealCondition.prototype.isAnimals = function () {
  return this.animalsAllowed;
};

DealCondition.prototype.getLabelAnimalsAllow = function () {
  if (this.isAnimals() === null) {
    return '';
  }

  return this.isAnimals() ? 'с\u00A0животными' : 'без\u00A0животных';
};

DealCondition.prototype.getPersonCount = function () {
  return this.personsCount;
};

DealCondition.prototype.getGenderPreference = function () {
  return this.genderPreference;
};

DealCondition.prototype.getLabelUtilitiesPrice = function () {
  const priceAdditionOptions = {
    0: '+\xa0оплата\xa0эл.\xa0энергии',
    1: (
      this.utilitiesPrice
        ? `+\xa0КУ\xa0(${this.utilitiesPrice.getLabel()}) +\xa0оплата\xa0эл.\xa0энергии`
        : '+\xa0КУ +\xa0оплата\xa0эл.\xa0энергии'
    ),
    2: '+\xa0по\xa0счетчикам',
    3: 'вкл.\xa0эл.\xa0эн.'
  };

  return priceAdditionOptions[this.utilitiesPayment] || null;
};

DealCondition.prototype.needDeposit = function () {
  return this.deposit;
};
DealCondition.prototype.getLabelDeposit = function () {
  return this.needDeposit() ? 'депозит' : '';
};

export default DealCondition;



// WEBPACK FOOTER //
// ./src/classes/announcement/dealCondition.js